<template>
  <v-card>
    <v-card-title
      class="d-flex justify-space-between align-center px-6 px-lg-10 py-6"
    >
      <h2 class="ma-0 text-bold font-28 primary--text">
        {{
          $vuetify.breakpoint.lgAndUp
            ? "Rent protection & Legal expenses eligibility check"
            : "Eligibility check"
        }}
      </h2>
      <v-btn icon class="btn-close" aria-label="Close" @click="cancel">
        <img src="@/assets/icons/ic_close.svg" />
      </v-btn>
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text
      ref="eligibilityContent"
      :style="`height: ${pslScrollHeight}`"
      class="pl-6 pl-lg-10 pr-1 pr-lg-5 py-6"
      @scroll="onContentScroll"
    >
      <LandlordsEligibilityCoverContent
        :showNewLetQuestion="true"
        @newLetStateChanged="onNewLetStateChanged"
      />
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions class="px-6 px-lg-10 py-6">
      <EligibilityActions
        :disabled="!hasScrolledToBottom"
        :confirmDisabled="!isConfirmEnabled || !hasScrolledToBottom"
        confirmText="CONFIRM ELIGIBILITY"
        dontMeetText="Don't meet eligibility criteria?"
        :buttonHeight="60"
        :minWidth="$vuetify.breakpoint.lgAndUp ? '420' : '100%'"
        confirmClass="text-uppercase"
        wrapperClass="d-flex flex-column justify-center align-center flex-grow-1"
        @confirm="handleConfirmEligibility"
        @dont-meet="handleEligibilityNotMet"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import LandlordsEligibilityCoverContent from "@/components/D2CSharedComponents/LandlordsEligibilityCoverContent.vue";
import EligibilityActions from "@/components/D2CSharedComponents/EligibilityActions.vue";
import EligibilityScrollMixin from "@/Mixins/EligibilityScrollMixin";

export default {
  name: "EligibilityCover",
  mixins: [EligibilityScrollMixin],
  components: {
    EligibilityActions,
    LandlordsEligibilityCoverContent,
  },
  props: {
    pslScrollHeight: {
      type: String,
      default: "auto",
    },
  },
  methods: {
    handleConfirmEligibility() {
      this.$emit("confirm-eligibility", this.newLetState.value);
    },
    handleEligibilityNotMet() {
      this.$emit("eligibility-not-meet");
    },
    cancel() {
      this.$emit("cancel-eligibility");
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.v-card__title) {
  h2 {
    max-width: 80%;
    word-break: break-word;
  }
}
</style>
